import {observer} from 'mobx-react-lite'
import React from 'react'
import {Util} from 'yougile-util'
import {PermissionRoleKey, User} from 'yougile-model'
import {DepartmentsClient} from '@client/departments-client'
import {EmployeeSettings} from '@client/employee-settings'
import {Highlight} from '@components/common/highlight/highlight'
import {ProjectRole} from '@components/project-participants/project-role'
import {UserAvatar} from '@components/user-avatar'
import {UserName} from '@components/user-name'
import {noPropagate} from '@containers/hooks'
import {Checkbox} from '../common/base/checkbox'
import {useProjectParticipantStore} from './project-participants-store'

interface Props {
  user: User
}

export const ProjectParticipantsRow = observer(({user}: Props) => {
  const bem = Util.bemFrom('project-participants')

  const [state, store] = useProjectParticipantStore()

  const toggle = () => {
    store.setChosenRoles({
      ...state.chosenRoles,
      [user.id]: state.chosenRoles[user.id]
        ? undefined
        : store.savedRolesRef[user.id] ?? 'worker'
    })
  }
  const setRole = (v: PermissionRoleKey) => {
    store.setChosenRoles({
      ...state.chosenRoles,
      [user.id]: v
    })
    store.savedRolesRef[user.id] = v
  }
  const position = EmployeeSettings.getPosition(user.id)
  const deps = DepartmentsClient.listForUser(store.box, user.id)
    .map(d => d.title)
    .join(', ')

  return (
    <div key={user.id} className={bem('item')} onClick={toggle}>
      <div className={bem('item-tick')}>
        <Checkbox value={!!state.chosenRoles[user.id]} />
      </div>
      <div className={bem('item-name')}>
        <UserAvatar size={18} user={user} />{' '}
        <UserName user={user} highlight={state.filter} className="truncate" />
      </div>
      <div className={bem('item-position')} title={position}>
        <Highlight text={position} highlight={state.filter} />
      </div>
      <div className={bem('item-deps')} title={deps}>
        <Highlight text={deps} highlight={state.filter} />
      </div>
      <div className={bem('item-roles')} onClick={noPropagate}>
        {state.chosenRoles[user.id] && (
          <ProjectRole
            className={bem('role')}
            value={state.chosenRoles[user.id]}
            onChange={setRole}
            customRoles={store.getCustomRoles()}
            addNewRole={store.createRole}
          />
        )}
      </div>
    </div>
  )
})
